import { makeApiRequest } from '../../utils/api-utils';

// Community Management Services
export const getAllCommunities = async (params?: {
  page?: number;
  page_size?: number;
}) => {
  const queryParams = new URLSearchParams();
  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.page_size) queryParams.append('page_size', params.page_size.toString());
  
  const queryString = queryParams.toString();
  const url = queryString ? `/community/get-all?${queryString}` : '/community/get-all';
  return makeApiRequest(url);
};

export const getCommunityById = async (id: string) => makeApiRequest(`/community/get-by-id/${id}`);
export const getMyCommunities = async (params?: {
  page?: number;
  page_size?: number;
}) => {
  const queryParams = new URLSearchParams();
  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.page_size) queryParams.append('page_size', params.page_size.toString());
  
  const queryString = queryParams.toString();
  const url = queryString ? `/community/my-communities?${queryString}` : '/community/my-communities';
  return makeApiRequest(url);
};

export const createCommunity = async (data: any) => makeApiRequest('/community/create', { 
  method: 'POST', 
  body: JSON.stringify(data) 
});
export const updateCommunity = async (data: any) => makeApiRequest('/community/update', { 
  method: 'PUT', 
  body: JSON.stringify(data) 
});
export const transferCommunityOwnership = async (id: string, newOwnerId: string) => 
  makeApiRequest(`/community/${id}/transfer-ownership`, { 
    method: 'POST', 
    body: JSON.stringify({ new_owner_id: newOwnerId }) 
  });
export const joinCommunity = async (id: string) => makeApiRequest(`/community/${id}/join`, { 
  method: 'POST' 
});
export const leaveCommunity = async (id: string) => makeApiRequest(`/community/${id}/leave`, { 
  method: 'POST' 
});
export const deleteCommunity = async (id: string) => makeApiRequest(`/community/delete/${id}`, { 
  method: 'DELETE' 
});
